import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Checkmark = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { points: "9.44911882 15.6785981 6.13018761 12.2580164 5 13.414616 9.44911882 18 19 8.15659955 17.8777715 7" })));
};
export default Checkmark;
